export default __webpack_public_path__ + "static/media/factionlessart2.417e286a.webp";